module.exports = __webpack_public_path__ + "78bdb7168ebc84e751bbdd29c3304c43.png";